import type { ReactNode } from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import AdBanner from './AdBanner';

export default function Layout({ children, showAds = true }: { children: ReactNode; showAds?: boolean }) {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      {showAds && (
        <div className="max-w-7xl mx-auto w-full px-4 pt-2">
          <AdBanner slot="1234567890" format="horizontal" className="min-h-[90px] bg-gray-100 rounded-lg" />
        </div>
      )}
      <main className="flex-1 max-w-7xl mx-auto w-full px-4 sm:px-6 lg:px-8 py-8">
        {children}
      </main>
      {showAds && (
        <div className="max-w-7xl mx-auto w-full px-4 pb-2">
          <AdBanner slot="0987654321" format="horizontal" className="min-h-[90px] bg-gray-100 rounded-lg" />
        </div>
      )}
      <Footer />
    </div>
  );
}
